// eslint-disable-next-line
import { useRegisterSW } from 'virtual:pwa-register/react';

import './reloadPrompt.scss';

function ReloadPrompt() {
    const {
        offlineReady: [hasOfflineReady, setOfflineReady],
        needRefresh: [hasNeedRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            console.log('SW Registered: ', r);
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    const close = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
    };

    // if (!hasOfflineReady && !hasNeedRefresh) {
    if (!hasNeedRefresh) {
        return null;
    }

    const isUpdate = hasNeedRefresh;

    return (
        <div className="rp-container">
            <div className="rp-toast">
                <div
                    className={`rp-icon ${
                        isUpdate ? 'rp-icon--update' : 'rp-icon--offline'
                    }`}
                >
                    {isUpdate ? (
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M20 11a8.1 8.1 0 0 0-15.5-2M4 5v4h4"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M4 13a8.1 8.1 0 0 0 15.5 2M20 19v-4h-4"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    ) : (
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M5 12.5 9.5 17 19 7.5"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                </div>

                <div className="rp-content">
                    <div className="rp-title">
                        {isUpdate
                            ? 'Nouvelle version disponible'
                            : 'Prêt à travailler hors ligne'}
                    </div>

                    <div className="rp-message">
                        {isUpdate
                            ? "Une nouvelle version de l'application est prête. Rechargez pour obtenir les dernières mises à jour."
                            : "L'application a été mise à jour et est désormais disponible hors ligne."}
                    </div>

                    <div className="rp-actions">
                        {isUpdate && (
                            <button
                                type="button"
                                className="rp-button rp-button--primary"
                                onClick={() => updateServiceWorker(true)}
                            >
                                Recharger
                            </button>
                        )}

                        <button
                            type="button"
                            className="rp-button rp-button--secondary"
                            onClick={close}
                        >
                            {isUpdate ? 'Plus tard' : 'Rejeter'}
                        </button>
                    </div>
                </div>

                <button
                    type="button"
                    className="rp-close"
                    onClick={close}
                    aria-label="Close notification"
                >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M6 6l12 12M18 6 6 18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default ReloadPrompt;
